export class OcorrenciaValidacaoVO {
    mensagem: string;
    siglaSeveridade: string;
    idObjetoValidado: string|undefined;
    impedeConfirmacao?: boolean;

    constructor(mensagem: string, siglaSeveridade: string, idObjetoValidado: string = '', impedeConfirmacao: boolean = false) {
        this.mensagem = mensagem;
        this.siglaSeveridade = siglaSeveridade;
        this.idObjetoValidado = idObjetoValidado;
        this.impedeConfirmacao = impedeConfirmacao;
    }

    getToastType(): string {
        switch (this.siglaSeveridade) {
            case 'I':
                return 'info';
            case 'A':
                return 'warning';
            case 'E':
                return 'warning';
            default:
                return 'error';
        }
    }
}
